function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.89 16.676l-3.106-3.109c1.016-1.467 1.524-3.104 1.524-4.907a8.51 8.51 0 00-.682-3.365 8.655 8.655 0 00-1.844-2.767A8.65 8.65 0 0012.016.683 8.5 8.5 0 008.654 0a8.498 8.498 0 00-3.362.683 8.65 8.65 0 00-2.766 1.845A8.657 8.657 0 00.682 5.295 8.514 8.514 0 000 8.66c0 1.172.227 2.293.682 3.364a8.655 8.655 0 001.844 2.767 8.652 8.652 0 002.766 1.845 8.5 8.5 0 003.362.683c1.803 0 3.438-.509 4.905-1.526l3.105 3.099a1.575 1.575 0 002.224.001 1.566 1.566 0 00.003-2.217zm-5.639-3.416c-1.273 1.274-2.806 1.911-4.597 1.911-1.791 0-3.324-.637-4.597-1.911-1.273-1.274-1.91-2.807-1.91-4.6 0-1.792.637-3.326 1.91-4.6C5.33 2.786 6.863 2.15 8.654 2.15c1.791 0 3.324.637 4.597 1.911 1.274 1.274 1.91 2.808 1.91 4.6 0 1.793-.637 3.326-1.91 4.6z"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;